import { render, staticRenderFns } from "./VOCApply.vue?vue&type=template&id=6340fdec&scoped=true&"
import script from "./VOCApply.vue?vue&type=script&lang=js&"
export * from "./VOCApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6340fdec",
  null
  
)

export default component.exports